exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.kpi-card[data-v-686a8372] {\r\n    border-radius: 10px;\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n.mr-3[data-v-686a8372] {\r\n    margin-right: 12px;\n}\n.kpi-value[data-v-686a8372] {\r\n    font-size: 2rem;\r\n    font-weight: bold;\n}\n.kpi-label[data-v-686a8372] {\r\n    font-size: 0.9rem;\r\n    opacity: 0.9;\n}\n.kpi-card-success[data-v-686a8372] {\r\n    background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\r\n    color: #fff;\n}\n.kpi-card-danger[data-v-686a8372] {\r\n    background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);\r\n    color: #fff;\n}\r\n", ""]);

// exports
